import axios from "axios";
import React from "react";

import { Form, Formik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";

import { EyeIcon, EyeSlashIcon } from "@heroicons/react/20/solid";
import { useDispatch, useSelector } from "react-redux";
import lock_img from "../../assets/password.svg";
import BZLogo from "../../components/BZLogo";
import { TwButton, TwInputGroup, TwMainLayout } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../redux/reducers/loadingReducer";
import { getUrlForUsers } from "../../utils/confighelpers";
import { useTranslation } from "react-i18next";
import I18nLanguageDropdown from "../../components/I18nLanguageDropdown";

export default function ResetPassword({ }) {
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog, closeNotificationDialog } = useToast();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const [passwordVisible, setPasswordVisible] = React.useState(false);

  if (!location.state) {
    navigate("/");
  }


  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <div className="min-h-screen bg-white flex flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="fixed top-5 right-5">
          <I18nLanguageDropdown />
        </div>
        <div className="sm:mx-auto sm:w-full sm:max-w-md flex flex-col gap-5">
          <BZLogo className="mx-auto" />
          {location.state && (<div className={"flex flex-col justify-center items-center gap-5 md:gap-8"}>
            <h2 className="text-center text-2xl md:text-3xl font-bold tracking-tight">
              {t("account.changePassword")}
            </h2>
          </div>)}
        </div>

        {location.state && (<div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <Formik
            initialValues={{
              password: "",
            }}
            validate={(values) => {
              const errors = {};
              if (!values.password) {
                errors.password = t("errors.required");
              }

              return errors;
            }}
            onSubmit={async (values) => {

              dispatch(setActionLoading(true));
              const request = await axios.put(
                `${getUrlForUsers()}resetForgotPassword`,
                {
                  password: values.password,
                  token: location.state.token,
                }
              );

              dispatch(setActionLoading(false));
              if (request.data.statusCode === 200) {
                addNotificationDialog({
                  dialogType: "success",
                  dialogTitle: t("linkDescription.success"),
                  dialogMessage: t("successes.passwordSuccessfully"),
                  dialogBtnTitle: t("successes.goBackToLoginBtn"),
                  dialogBackdropClick: async () => {
                    closeNotificationDialog();
                    navigate("/");
                  },
                  dialogBtnClick: async () => {
                    closeNotificationDialog();
                    navigate("/");
                  },
                })
              } else {
                addErrorToast(request.data.message);
              }
            }}
          >
            {({
              values,
              errors,
              setFieldValue,
              handleBlur,
              submitForm,
              isSubmitting,
            }) => (
              <Form>
                <div className={"flex flex-col gap-4"}>

                  <TwInputGroup
                    label={t("account.newPassword")}
                    placeholder={t("inputFieldsTitle.passwordPlaceholder")}
                    name={"password"}
                    type={passwordVisible ? "text" : "password"}
                    leftIcon={(<img className={""} src={lock_img} alt={""} />)}
                    rightIcon={
                      passwordVisible ? (
                        <EyeIcon className="size-5" onClick={() => setPasswordVisible(!passwordVisible)} />
                      ) : (
                        <EyeSlashIcon className="size-5" onClick={() => setPasswordVisible(!passwordVisible)} />
                      )
                    }
                    onChange={(e) => {
                      setFieldValue("password", e.target.value);
                    }}
                    errors={errors}
                  />
                  <TwButton
                    variant={"secondary"}
                    onClick={submitForm}
                    disabled={loadingReduxState.actionLoading || isSubmitting}
                    actionLoading={(loadingReduxState.actionLoading)}
                    className="w-full xs:text-base sm:text-xl md:py-3.5"
                    type="submit"
                  >
                    {t("inputFieldsTitle.continue")}
                  </TwButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>)}
      </div>
    </TwMainLayout>)
}
